<template>
  <auth-layout>
    <div class="mb-6 xl:mb-12">
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold">
        Login
      </h2>

      <aside
        class="mt-6 p-4 text-sm border-l-8 border-neutral-400 bg-neutral-50 text-neutral-700"
        style="text-wrap: balance;"
      >
        <b>Mobilise</b> is an evolution of APCs previous accelerator,
        <b>TDAP</b>. If you have previously used the TDAP portal, please use
        these credentials to login.
      </aside>
    </div>
    <form @submit.prevent="login">
      <auth-input
        v-model="auth.email"
        label="Email"
        input-type="email"
        :error="getError('email')"
        :required="true"
        placeholder="e.g. your.name@email.com"
        :loading="loading"
        :autocomplete="true"
      />

      <auth-input
        v-model="auth.password"
        label="Password"
        input-type="password"
        :error="getError('password')"
        :required="true"
        placeholder="Your Password"
        :loading="loading"
        :autocomplete="true"
      />

      <div class="flex flex-wrap items-center">
        <div class="w-full sm:w-1/2 text-left">
          <input-checkbox
            v-model="auth.remember"
            label="Remember Me"
            input-type="checkbox"
          />
        </div>
        <div class="w-full sm:w-1/2 text-right">
          <icon-link :href="route('password.request')">
            Forgotten your login details?
          </icon-link>
        </div>
      </div>

      <app-button type="submit" class="mt-8 mb-4" :disabled="loading">
        Login
      </app-button>

      <p class="text-center">
        <icon-link :href="route('register')" icon="add-circle" class="mx-2">
          Create an account
        </icon-link>
        <a
          class="icon-link underline mx-2"
          :href="
            `mailto:${$config.emails.technical}?subject=${$config.name} Login issue`
          "
        >
          Having problems logging in?
        </a>
      </p>
    </form>
  </auth-layout>
</template>

<script>
import { requestMixin } from "../mixins/request";
export default {
  name: "Login",
  mixins: [requestMixin],
  data() {
    return {
      auth: {
        email: "",
        password: "",
        remember: false
      },
      loading: false
    };
  },
  created() {
    document.title = `Login :: ${document.title}`;
  },
  methods: {
    login() {
      this.loading = true;
      return axios
        .post(route("login"), this.auth)
        .then(response => {
          this.loginResponse(response);
        })
        .catch(error => {
          if (
            error.response.status == 403 &&
            error.response.data.message == "Your email address is not verified."
          ) {
            window.location.href = "/";
          }
          this.requestError(error);
        })
        .then(() => (this.loading = false));
    },
    loginResponse() {
      Turbolinks.visit(route("home"));
    }
  }
};
</script>

<style></style>
